import localforage from 'localforage';

const CACHE_PREFIX = 'vfm_cms_';

const cacheStore = localforage.createInstance({
  name: 'vfm_cms_cache',
  storeName: 'cache',
});

export async function getCachedData(key) {
  if (typeof window === 'undefined') return null;

  try {
    const payload = await cacheStore.getItem(CACHE_PREFIX + key);
    if (!payload) return null;
    return payload;
  } catch (error) {
    console.error('Failed to read from cache storage', error);
    return null;
  }
}

export function setCachedData(key, data) {
  if (typeof window === 'undefined') return;

  try {
    const payload = {
      data,
      timestamp: Date.now(),
    };

    cacheStore.setItem(CACHE_PREFIX + key, payload).catch((error) => {
      console.error('Failed to write to cache storage', error);
    });
  } catch (error) {
    console.error('Failed to write to cache storage', error);
  }
}

export function clearCacheKey(key) {
  if (typeof window === 'undefined') return;

  try {
    cacheStore.removeItem(CACHE_PREFIX + key).catch((error) => {
      console.error('Failed to clear cache key', error);
    });
  } catch (error) {
    console.error('Failed to clear cache key', error);
  }
}

export function clearAllCache() {
  if (typeof window === 'undefined') return;

  try {
    cacheStore.clear().catch((error) => {
      console.error('Failed to clear cache', error);
    });
  } catch (error) {
    console.error('Failed to clear cache', error);
  }
}

export function isCacheStale(payload, maxAgeMs) {
  if (!payload || !payload.timestamp) return true;
  if (!maxAgeMs) return false;
  return Date.now() - payload.timestamp > maxAgeMs;
}
